import { render, staticRenderFns } from "./OctSalonCustomerList.vue?vue&type=template&id=283af560&scoped=true&"
import script from "./OctSalonCustomerList.vue?vue&type=script&lang=js&"
export * from "./OctSalonCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./OctSalonCustomerList.vue?vue&type=style&index=0&id=283af560&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283af560",
  null
  
)

export default component.exports